<template>
  <BoardData />
  <PriorityData />
  <TeamMemberData />
  <LabelData />
  <div class="card overflow-hidden">
    <nav class="tsk_tabs">
      <div class="nav nav-tabs m-0" id="nav-tab" role="tablist">
        <router-link to="/complain" class="nav-link" id="nav-archive-tab">
          <span class="tabLinkCls">List</span>
        </router-link>
        <router-link to="/complain-kanban" class="nav-link" id="nav-karban-tab">
          <span class="tabLinkCls">Kanban</span>
        </router-link>
        <button class="nav-link active tabLinkCls">Archive</button>
      </div>
      <div class="mg-right_divselt">
      </div>
    </nav>
    <div class="tab-content p-0" id="nav-tabContent">
      <div
        class="tab-pane fade active show"
        id="nav-list"
        role="tabpanel"
        aria-labelledby="nav-list-tab"
      >
        <div class="card border-0">
          <!-- <div class="card-header py-3">
                        <h6 class="m-0 font-weight-bold text-primary">Tasks</h6>
                    </div> -->
          <div class="sectionclsbodymain tsk_body_right_back">
            <Tasks />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tasks from "../components/Tasks/archive.vue";
import PriorityData from "../components/Priority/PriorityData.vue";
import BoardData from "../components/Board/BoardData.vue";
import TeamMemberData from "../components/TeamMember/TeamMemberData.vue";
import LabelData from "../components/Label/LabelData.vue";
// import AddSvgIcon from '../components/Widgets/Icon/AddSvgIcon.vue'
// import LabelsSvgIcon from '../components/Widgets/Icon/LabelsSvgIcon.vue'
import $ from "jquery";
export default {
  name: "TasksPage",
  components: {
    Tasks,
    PriorityData,
    BoardData,
    TeamMemberData,
    LabelData,
    // AddSvgIcon,
    // LabelsSvgIcon,
  },
  async mounted() {
    $("#content").addClass("firstHeightCls");
    if (window.innerWidth < 1025) {
      $(".firstHeightCls").height(window.innerHeight);
    } else {
      const bHeight = $("body").height();
      $(".firstHeightCls").height(bHeight - 30);
    }
    this.$store.state.NotifiCheckVal = Math.ceil(Math.random() * 1000000);
    if (this.$store.state.isActiveToken != "1") {
      // console.log(this.currentDate);
    }
    $(".taskMenuCls").addClass("router-link-active");
    if ($(".sectionbody").hasClass("showMobileMenu")) {
      $(".sectionbody").removeClass("showMobileMenu");
    }
  },
  beforeRouteLeave(to, from, next) {
    // console.log(to);
    // console.log(from);
    // console.log(next);
    $(".taskMenuCls").removeClass("router-link-active");
    next();
  },
  methods: {
    async addTaskBtn() {
      document.getElementById("addTaskMainBtn").click();
    },
    async manageLabelsBtn() {
      document.getElementById("addManageLabelsBtn").click();
    },
  },
};
</script>
